import JSZip from "jszip";
import { lookup } from "mrmime";
import { v4 as uuidv4 } from "uuid";

import { AppPackageEditorFileTypes } from "../abstractions/EPackageEditor";
import { IAppPackageEditorFile } from "../abstractions/IPackageEditor";
import { base64ToUint8Array } from "./utils";

export const extname = (filename: string) => filename.split('.').pop() || "";

function getAssetType(fileId: string): "string" | "base64" {
  if (lookup(extname(fileId))?.includes("image")) {
    return "base64";
  } else {
    return "string";
  }
}

function getAssetFileType(fileName: string): AppPackageEditorFileTypes {
  const ext = extname(fileName);
  switch (ext) {
    case "json":
      return AppPackageEditorFileTypes.Json;
    case "yaml":
    case "yml":
      return AppPackageEditorFileTypes.Yaml;
    case "png":
      return AppPackageEditorFileTypes.Png;
    default:
      return AppPackageEditorFileTypes.Unsupported
  }
}

export function parseContent(extname: string, fileContent: string) {
  if (!fileContent || fileContent === "") {
    return "No content"
  }
  switch (extname) {
    case "png":
      return base64ToUint8Array(fileContent);
    case "json":
    case "yaml":
    case "yml":
    default:
      return fileContent;
  }
}

export const parseZipPackage = async (file: string) =>
  JSZip.loadAsync(file, { base64: true })
    .then(pkg => {
      return Promise.all(
        Object.keys(pkg.files).map((fileId) => {
          const zipFile = pkg.file(fileId);
          const ext = extname(fileId);
          const assetType = getAssetType(fileId);
          return zipFile
            ? zipFile
              .async(assetType)
              .then((fileContent) => [
                fileId,
                parseContent(ext, fileContent)
              ])
            : Promise.resolve([fileId, zipFile]);
        })
      )
    })
    .then((arrayObjects) => new Map(arrayObjects.map((result) => [result[0], result[1]])))
    .then((contents) => {

      const packageFiles: IAppPackageEditorFile[] = [];

      contents.get("manifest.json") && packageFiles.push(
        {
          id: uuidv4(),
          name: "manifest.json",
          fileType: AppPackageEditorFileTypes.Manifest,
          content: contents.get("manifest.json"),
          isModified: false,
        }
      )
      contents.get("color.png") && packageFiles.push(
        {
          id: uuidv4(),
          name: "color.png",
          fileType: AppPackageEditorFileTypes.Icon,
          content: contents.get("color.png"),
          isModified: false
        }
      );
      contents.get("outline.png") && packageFiles.push(
        {
          id: uuidv4(),
          name: "outline.png",
          fileType: AppPackageEditorFileTypes.OutLine,
          content: contents.get("outline.png"),
          isModified: false
        }
      );
      const unassignedContents = contents;
      const assignedContentNames = ["manifest.json", "definition", "color.png", "outline.png"];
      assignedContentNames.forEach((name) => unassignedContents.delete(name));
      unassignedContents.forEach((parsedContent, name) => {
        packageFiles.push(
          {
            id: uuidv4(),
            name: name as string,
            fileType: getAssetFileType(name as string),
            content: parsedContent,
            isModified: false
          }
        );
      });
      return packageFiles;
    })
    .catch(error => {
      // Log Error Here
      return null;
    });
